import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { screenHeightLeftFromTop } from "Constants";
import LocaleStrings from "Languages";
import SocialfeedMenuIcon from "./socialfeed-menu-icon";
import TableContentTopSocialEngahement from "./socialfeed-engagement-list";
import PaiCharSocialfeedContaint from "./socialfeed-paichart-postingtypes";
import AnalyticsCommonHeader from "AnalyticscommonAnalyticscommon";
import {
  fetchTopSocialfeedEngagementTableData,
  fetchSocialfeedPostypePaichart,
} from "SocialfeedActions";

//import from actions
import {
  SOCIALFEED_POST,
  SOCIALFEED_REACTION,
  SOCIALFEED_COMMENT,
  SOCIALFEED_MEDIA,
  SOCIALFEED_POLL,
} from "SocialfeedActions";

import { socialfeedpostcount } from "SocialfeedPostAction";
import { socialfeedreactioncount } from "SocialfeedReactionAction"; // Getting getdata count fc from actions
import { socialfeedcommentcount } from "SocialfeedCommentAction"; // Getting getdata count fc from actions
import { socialfeedmediacount } from "SocialfeedMediaAction"; // Getting getdata count fc from actions
import { socialfeedpollcount } from "SocialfeedPollAction"; // Getting getdata count fc from actions

var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class SocialfeedInside extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      desc: LocaleStrings.analytics_text_preparing_analytics,
    };
  }

  //
  componentDidMount() {
    this.props.socialfeedpostcount(
      this.props.session,
      (socialfeedpostresponse) => {
        if (socialfeedpostresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.socialfeedreactioncount(
      this.props.session,
      (socialfeedreactionresponse) => {
        if (socialfeedreactionresponse.error === 0) {
        }
      }
    );

    this.props.socialfeedcommentcount(
      this.props.session,
      (socialfeedcommentresponse) => {
        if (socialfeedcommentresponse.error === 0) {
        }
      }
    );

    this.props.socialfeedmediacount(
      this.props.session,
      (socialfeedmediaresponse) => {
        if (socialfeedmediaresponse.error === 0) {
        }
      }
    );

    this.props.socialfeedmediacount(
      this.props.session,
      (socialfeedmediaresponse) => {
        if (socialfeedmediaresponse.error === 0) {
        }
      }
    );

    this.props.socialfeedpollcount(
      this.props.session,
      (socialfeedpollresponse) => {
        if (socialfeedpollresponse.error === 0) {
        }
      }
    );

    // Socialfeed Engagement (top users who were active on socialfeed app) Table List
    this.props.fetchTopSocialfeedEngagementTableData(
      this.props.session,
      (fetchtopsocialfeedengagementResponce) => {
        this.setState({ loading: false });
      }
    );

    this.props.fetchSocialfeedPostypePaichart(
      this.props.session,
      (fetchsocialfeedpostypepaichartResponce) => {
        this.setState({ loading: false });
      }
    );
  }

  //Arrow function for renderLoader
  renderLoader = () => {
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };

  // Arrow function for render Social feed menu divs
  renderSocialfeedMenuIcons() {
    return _.map(this.props.socialFeedMenu, (socialfeedmenuItem) => {
      return (
        <SocialfeedMenuIcon
          menu={socialfeedmenuItem}
          key={socialfeedmenuItem.key}
        />
      );
    });
  }

  // Rerender All componets on this page
  mainCallback = () => {
    this.setState({ loading: true });

    this.props.socialfeedpostcount(
      this.props.session,
      (socialfeedpostresponse) => {
        if (socialfeedpostresponse.error === 0) {
          // this.setState({loading:false});
        }
      }
    );

    this.props.socialfeedreactioncount(
      this.props.session,
      (socialfeedreactionresponse) => {
        if (socialfeedreactionresponse.error === 0) {
        }
      }
    );

    this.props.socialfeedcommentcount(
      this.props.session,
      (socialfeedcommentresponse) => {
        if (socialfeedcommentresponse.error === 0) {
        }
      }
    );

    this.props.socialfeedmediacount(
      this.props.session,
      (socialfeedmediaresponse) => {
        if (socialfeedmediaresponse.error === 0) {
        }
      }
    );

    this.props.socialfeedmediacount(
      this.props.session,
      (socialfeedmediaresponse) => {
        if (socialfeedmediaresponse.error === 0) {
        }
      }
    );

    this.props.socialfeedpollcount(
      this.props.session,
      (socialfeedpollresponse) => {
        if (socialfeedpollresponse.error === 0) {
        }
      }
    );

    // Socialfeed Engagement (top users who were active on socialfeed app) Table List
    this.props.fetchTopSocialfeedEngagementTableData(
      this.props.session,
      (fetchtopsocialfeedengagementResponce) => {
        this.setState({ loading: false });
      }
    );

    this.props.fetchSocialfeedPostypePaichart(
      this.props.session,
      (fetchsocialfeedpostypepaichartResponce) => {
        this.setState({ loading: false });
      }
    );
  };

  render() {
    let { deviceSize } = this.props;

    return (
      <div className="panel noborder-panel">
        {/* Header section */}
        {!this.state.loading ? (
          <AnalyticsCommonHeader
            finishOperationsCallback={this.mainCallback}
            callFrom="socialfeed"
          />
        ) : (
          ""
        )}

        <div
          className="panel-body scrollable-content"
          style={{
            height: deviceSize.height - screenHeightLeftFromTop,
          }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              {this.renderLoader()}
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <div>
              <ul className="nav nav-pills dashboardNavPill">
                {this.renderSocialfeedMenuIcons()}
              </ul>
              <div className="mt-20"></div>
              <div className="panel-body ">
                <TableContentTopSocialEngahement
                  state={this.props.postypepaichart}
                />
                <PaiCharSocialfeedContaint />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var { session, user, socialFeedMenu, socialfeedSelectedItem } = state;

  var totalpost = state.socialfeedTotalPost ? state.socialfeedTotalPost : [];
  var totalreaction = state.socialfeedTotalReaction
    ? state.socialfeedTotalReaction
    : [];
  var totalcomment = state.socialfeedTotalComment
    ? state.socialfeedTotalComment
    : [];
  var totalmedia = state.socialfeedTotalMedia ? state.socialfeedTotalMedia : [];
  var totalpoll = state.socialfeedTotalPoll ? state.socialfeedTotalPoll : [];
  var totalpoll = state.socialfeedTousersEngagetablelist
    ? state.socialfeedTousersEngagetablelist
    : [];
  var postypepaichart = state.socialfeedPostypePaichartData
    ? state.socialfeedPostypePaichartData
    : [];

  return {
    session,
    user,
    socialFeedMenu,
    socialfeedSelectedItem,
    deviceSize: state.deviceSize,
    totalpost,
    totalreaction,
    totalcomment,
    totalmedia,
    totalpoll,
    postypepaichart,
  };
}

// Export with connect
export default connect(mapStateToProps, {
  socialfeedpostcount,
  socialfeedreactioncount,
  socialfeedcommentcount,
  socialfeedmediacount,
  socialfeedpollcount,
  fetchTopSocialfeedEngagementTableData,
  fetchSocialfeedPostypePaichart,
})(SocialfeedInside);
